package com.anjuros.website.redesign.sections.contactforms

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.jsonString
import com.anjuros.website.redesign.components.rdBreadcrumbJsonLd
import com.anjuros.website.redesign.components.rdFaqJsonLd
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL

/** JSON-LD for the Contact forms page: the page and its service, the breadcrumb and the FAQ. */
@Composable
fun contactFormsStructuredData(): String {
    val name = LocalText(RdText.FORMS_HERO_TITLE_START) + LocalText(RdText.FORMS_HERO_TITLE_MARK)
    val breadcrumb = rdBreadcrumbJsonLd(RdText.FORMS_CRUMB, RdRoute.CONTACT_FORMS)
    val faq = rdFaqJsonLd(ContactFormsFaqs)
    return """
        {"@context":"https://schema.org","@graph":[
         {"@type":"WebPage","url":"$SITE_URL${RdRoute.CONTACT_FORMS}","name":${jsonString(name)},
          "about":{"@type":"Service","name":"Custom website contact forms","provider":{"@id":"$SITE_URL/#business"}}},
         $breadcrumb,
         $faq
        ]}
    """.trimIndent()
}
